import go from '@/gojs/go'

const base = [
  go.units.specialities.AdCan,
  go.units.specialities.AdChirAut,
  go.units.specialities.AdChirCan,
  go.units.specialities.AdChirCar,
  go.units.specialities.AdChirCva,
  go.units.specialities.AdChirDig,
  go.units.specialities.AdChirGen,
  go.units.specialities.AdChirNeu,
  go.units.specialities.AdChirOph,
  go.units.specialities.AdChirOrl,
  go.units.specialities.AdChirOrt,
  go.units.specialities.AdChirPla,
  go.units.specialities.AdChirMax,
  go.units.specialities.AdChirSto,
  go.units.specialities.AdChirSur,
  go.units.specialities.AdChirTra,
  go.units.specialities.AdChirTho,
  go.units.specialities.AdChirUro,
  go.units.specialities.AdChirVas
]

const base2 = [
  go.units.specialities.AdEhp,
  go.units.specialities.AdHad,
  go.units.specialities.AdHem,
  go.units.specialities.AdMedAut,
  go.units.specialities.AdMedCar,
  go.units.specialities.AdMedDer,
  go.units.specialities.AdMedGen,
  go.units.specialities.AdMedGer,
  go.units.specialities.AdMedHge,
  go.units.specialities.AdMedInf,
  go.units.specialities.AdMedInt,
  go.units.specialities.AdMedJou,
  go.units.specialities.AdMedNep,
  go.units.specialities.AdMedNeu,
  go.units.specialities.AdMedNut,
  go.units.specialities.AdMedPal,
  go.units.specialities.AdMedPne,
  go.units.specialities.AdMedRhu,
  go.units.specialities.AdMedSur,
  go.units.specialities.AdMedUsi,
  go.units.specialities.AdObsObs,
  go.units.specialities.AdObsChir,
  go.units.specialities.AdObsGyn,
  go.units.specialities.AdObsAut,
  go.units.specialities.AdPsy,
  go.units.specialities.AdRad,
  go.units.specialities.AdReaAut,
  go.units.specialities.AdReaBru,
  go.units.specialities.AdReaCar,
  go.units.specialities.AdReaChir,
  go.units.specialities.AdReaMed,
  go.units.specialities.AdReaNeu,
  go.units.specialities.AdReaPol,
  go.units.specialities.AdSld,
  go.units.specialities.AdSsrRee,
  go.units.specialities.AdSsrAut,
  go.units.specialities.AdUrg,
  go.units.specialities.MixRea,
  go.units.specialities.NeoRea,
  go.units.specialities.NeoMed,
  go.units.specialities.NeoMedSur,
  go.units.specialities.NeoUrg,
  go.units.specialities.NeoChir,
  go.units.specialities.NeoChirSur,
  go.units.specialities.PedCan,
  go.units.specialities.PedDia,
  go.units.specialities.PedChir,
  go.units.specialities.PedChirSur,
  go.units.specialities.PedHad,
  go.units.specialities.PedMedAut,
  go.units.specialities.PedMedSur,
  go.units.specialities.PedMedHge,
  go.units.specialities.PedPsy,
  go.units.specialities.PedRea,
  go.units.specialities.PedSld,
  go.units.specialities.PedSsr,
  go.units.specialities.PedUrg
]

const adDia = {
  v1: [ go.units.specialities.AdDia ],
  v2: [
    go.units.specialities.AdDiaDom,
    go.units.specialities.AdDiaHdc,
    go.units.specialities.AdDiaUdm,
    go.units.specialities.AdDiaUad
  ]
}

function codeFilter (list) {
  return e => list.indexOf(e.code) !== -1
}

const list = {
  v1: [...base, ...adDia.v1, ...base2],
  v2: [...base, ...adDia.v2, ...base2]
}

const isInfADI = {
  v1: (index) => index >= 1 && index <= 19,
  v2: (index) => index >= 1 && (index <= 17 || (index >= 78 && index <= 81))
}

const isDia = {
  v1: (index) => index === 18 || index === 19,
  v2: (index) => index >= 78 && index <= 81
}

const infADI = {
  v1: list.v1.filter(e => isInfADI.v1(e.index)),
  v2: list.v2.filter(e => isInfADI.v2(e.index))
}

function isNeo (index) {
  return index === 14 || index === 15 || index === 16
}

function isMix (index) {
  return index === 17
}

function isAdRea (index) {
  return index >= 1 && index <= 7
}

const adRea = list.v1.filter(e => isAdRea(e.index))
const adMed = list.v1.filter(
  codeFilter(
    [
      go.units.specialities.AdMedSur.code,
      go.units.specialities.AdMedUsi.code,
      go.units.specialities.AdMedGen.code,
      go.units.specialities.AdMedInt.code,
      go.units.specialities.AdMedPne.code,
      go.units.specialities.AdMedCar.code,
      go.units.specialities.AdMedNep.code,
      go.units.specialities.AdMedHge.code,
      go.units.specialities.AdMedDer.code,
      go.units.specialities.AdMedNut.code,
      go.units.specialities.AdMedRhu.code,
      go.units.specialities.AdMedNeu.code,
      go.units.specialities.AdMedGer.code,
      go.units.specialities.AdMedInf.code,
      go.units.specialities.AdMedJou.code,
      go.units.specialities.AdMedPal.code,
      go.units.specialities.AdMedAut.code
    ]
  )
)

const adUrg = list.v1.filter(codeFilter(['AD URG']))

const adChir = list.v1.filter(
  codeFilter(
    [
      go.units.specialities.AdChirSur.code,
      go.units.specialities.AdChirTho.code,
      go.units.specialities.AdChirCar.code,
      go.units.specialities.AdChirVas.code,
      go.units.specialities.AdChirCva.code,
      go.units.specialities.AdChirNeu.code,
      go.units.specialities.AdChirDig.code,
      go.units.specialities.AdChirGen.code,
      go.units.specialities.AdChirOrt.code,
      go.units.specialities.AdChirPla.code,
      go.units.specialities.AdChirOrl.code,
      go.units.specialities.AdChirOph.code,
      go.units.specialities.AdChirMax.code,
      go.units.specialities.AdChirSto.code,
      go.units.specialities.AdChirUro.code,
      go.units.specialities.AdChirCan.code,
      go.units.specialities.AdChirTra.code,
      go.units.specialities.AdChirAut.code
    ]
  )
)

const adObs = list.v1.filter(
  codeFilter(
    [
      go.units.specialities.AdObsObs.code,
      go.units.specialities.AdObsChir.code,
      go.units.specialities.AdObsGyn.code,
      go.units.specialities.AdObsAut.code
    ]
  )
)

const adSSR = list.v1.filter(
  codeFilter(
    [
      go.units.specialities.AdSsrRee.code,
      go.units.specialities.AdSsrAut.code
    ]
  )
)

const adPsy = list.v1.filter(codeFilter([go.units.specialities.AdPsy.code]))
const adHAD = list.v1.filter(codeFilter([go.units.specialities.AdHad.code]))
const adSLD = list.v1.filter(codeFilter([go.units.specialities.AdSld.code]))
const adEHP = list.v1.filter(codeFilter([go.units.specialities.AdEhp.code]))

const pedRea = list.v1.filter(codeFilter([go.units.specialities.PedRea.code]))
const pedMed = list.v1.filter(
  codeFilter(
    [
      go.units.specialities.PedMedSur.code,
      go.units.specialities.PedMedHge.code,
      go.units.specialities.PedMedAut.code
    ]
  )
)
const pedUrg = list.v1.filter(codeFilter([go.units.specialities.PedUrg.code]))

const pedChir = list.v1.filter(
  codeFilter(
    [
      go.units.specialities.PedChirSur.code,
      go.units.specialities.PedChir.code
    ]
  )
)
const pedSSR = list.v1.filter(codeFilter([go.units.specialities.PedSsr.code]))
const pedPsy = list.v1.filter(codeFilter([go.units.specialities.PedPsy.code]))
const pedDia = list.v1.filter(codeFilter([go.units.specialities.PedDia.code]))
const pedHAD = list.v1.filter(codeFilter([go.units.specialities.PedHad.code]))
const pedSld = list.v1.filter(codeFilter([go.units.specialities.PedSld.code]))

const neoRea = list.v1.filter(codeFilter([go.units.specialities.NeoRea.code]))

const neoMed = list.v1.filter(
  codeFilter(
    [
      go.units.specialities.NeoMedSur.code,
      go.units.specialities.NeoMed.code
    ]
  )
)
const neoUrg = list.v1.filter(codeFilter([go.units.specialities.NeoUrg.code]))

const neoChir = list.v1.filter(
  codeFilter(
    [
      go.units.specialities.NeoChirSur.code,
      go.units.specialities.NeoChir.code
    ]
  )
)

const mixRea = list.v1.filter(codeFilter([go.units.specialities.MixRea.code]))

const disc = (function () {
  function build (adDiaList, adDiaExpands) {
    return {
      adRea: {
        id: 'adRea',
        list: adRea,
        index: 1000,
        sortIndex: 10900,
        code: 'AD REA',
        expands: [
          {
            index: 2003,
            code: go.units.specialities.AdReaAut.code,
            unitType: go.units.specialities.AdReaAut.index,
            id: 'adReaAut',
            sortIndex: 10899,
            type: 1
          },
          {
            index: 2004,
            code: go.units.specialities.AdReaBru.code,
            unitType: go.units.specialities.AdReaBru.index,
            id: 'adReaBru',
            sortIndex: 10898,
            type: 1
          },
          {
            index: 2005,
            code: go.units.specialities.AdReaCar.code,
            unitType: go.units.specialities.AdReaCar.index,
            id: 'adReaCar',
            sortIndex: 10897,
            type: 1
          },
          {
            index: 2006,
            code: go.units.specialities.AdReaChir.code,
            unitType: go.units.specialities.AdReaChir.index,
            id: 'adReaChir',
            sortIndex: 10896,
            type: 1
          },
          {
            index: 2007,
            code: go.units.specialities.AdReaMed.code,
            unitType: go.units.specialities.AdReaMed.index,
            id: 'adReaMed',
            sortIndex: 10895,
            type: 1
          },
          {
            index: 2008,
            code: go.units.specialities.AdReaNeu.code,
            unitType: go.units.specialities.AdReaNeu.index,
            id: 'adReaNeu',
            sortIndex: 10894,
            type: 1
          },
          {
            index: 2009,
            code: go.units.specialities.AdReaPol.code,
            unitType: go.units.specialities.AdReaPol.index,
            id: 'adReaPol',
            sortIndex: 10893,
            type: 1
          }
        ]
      },

      adMed: {
        id: 'adMed',
        list: adMed,
        index: 1001,
        code: 'AD MED',
        type: 3,
        sortIndex: 9900,
        excludeExpands: true,
        optionals: [
          {
            index: 2010,
            code: go.units.specialities.AdMedNep.code,
            unitType: go.units.specialities.AdMedNep.index,
            subtitle: '<strong><small>Optionnel</small></strong>',
            id: 'adMedNep',
            sortIndex: 9850,
            optional: true,
            type: 4
          }
        ]
      },

      adCan: {
        id: 'adCan',
        list: [go.units.specialities.AdCan],
        index: 2000,
        code: go.units.specialities.AdCan.code,
        type: 3,
        sortIndex: 9899
      },

      adRad: {
        id: 'adRad',
        list: [go.units.specialities.AdRad],
        index: 2001,
        code: go.units.specialities.AdRad.code,
        type: 3,
        sortIndex: 9898
      },

      adHem: {
        id: 'adHem',
        list: [go.units.specialities.AdHem],
        index: 2002,
        code: go.units.specialities.AdHem.code,
        sortIndex: 9897,
        type: 3
      },

      adUrg: {
        id: 'adUrg',
        index: 1002,
        list: adUrg,
        code: 'AD URG',
        sortIndex: 8400,
        type: 1
      },

      adChir: {
        id: 'adChir',
        index: 1003,
        list: adChir,
        code: 'AD CHIR',
        sortIndex: 7900,
        type: 3
      },

      adObs: {
        id: 'adObs',
        index: 1004,
        list: adObs,
        code: 'AD OBS',
        sortIndex: 6900,
        type: 2
      },

      adSSR: {
        id: 'adSsr',
        index: 1005,
        list: adSSR,
        code: 'AD SSR',
        sortIndex: 6800,
        type: 1
      },

      adPsy: {
        id: 'adPsy',
        index: 1006,
        list: adPsy,
        code: 'AD PSY',
        sortIndex: 5900,
        type: 1
      },

      adDia: {
        id: 'adDia',
        index: 1007,
        list: adDiaList,
        code: 'AD DIA',
        sortIndex: 8900,
        expands: adDiaExpands,
        type: 5
      },

      adHAD: {
        id: 'adHad',
        index: 1008,
        list: adHAD,
        code: 'AD HAD',
        sortIndex: 2900,
        type: 6
      },

      adSLD: {
        id: 'adSld',
        index: 1009,
        list: adSLD,
        code: 'AD SLD',
        sortIndex: 4900,
        type: 1
      },

      adEHP: {
        id: 'adEhp',
        index: 1010,
        list: adEHP,
        code: 'AD EHP',
        sortIndex: 3900,
        type: 1
      },

      pedRea: {
        id: 'pedRea',
        index: 1100,
        list: pedRea,
        code: 'PED REA',
        sortIndex: 10800,
        type: 1
      },

      pedMed: {
        id: 'pedMed',
        index: 1101,
        list: pedMed,
        code: 'PED MED',
        sortIndex: 9800,
        type: 3
      },

      pedCan: {
        id: 'pedCan',
        index: 2100,
        list: [go.units.specialities.PedCan],
        code: go.units.specialities.PedCan.code,
        sortIndex: 9799,
        type: 3
      },

      pedUrg: {
        id: 'pedUrg',
        index: 1102,
        list: pedUrg,
        code: 'PED URG',
        sortIndex: 8300,
        type: 1
      },

      pedChir: {
        id: 'pedChir',
        index: 1103,
        list: pedChir,
        code: 'PED CHIR',
        sortIndex: 7800,
        type: 3
      },

      pedSSR: {
        id: 'pedSsr',
        index: 1104,
        list: pedSSR,
        code: 'PED SSR',
        sortIndex: 6700,
        type: 1
      },

      pedPsy: {
        id: 'pedPsy',
        index: 1105,
        list: pedPsy,
        code: 'PED PSY',
        sortIndex: 5800,
        type: 1
      },

      pedDia: {
        id: 'pedDia',
        index: 1106,
        list: pedDia,
        code: 'PED DIA',
        sortIndex: 8800,
        type: 5
      },

      pedHAD: {
        id: 'pedHad',
        index: 1107,
        list: pedHAD,
        code: 'PED HAD',
        sortIndex: 2800,
        type: 6
      },

      pedSld: {
        id: 'pedSld',
        index: 1108,
        list: pedSld,
        code: 'PED SLD',
        sortIndex: 4800,
        type: 1
      },

      neoRea: {
        id: 'neoRea',
        index: 1200,
        list: neoRea,
        code: 'NEO REA',
        sortIndex: 10700,
        type: 1
      },

      neoMed: {
        id: 'neoMed',
        index: 1201,
        list: neoMed,
        code: 'NEO MED',
        sortIndex: 9700,
        type: 1
      },

      neoUrg: {
        id: 'neoUrg',
        index: 1202,
        list: neoUrg,
        code: 'NEO URG',
        sortIndex: 8200,
        type: 1
      },

      neoChir: {
        id: 'neoChir',
        index: 1203,
        list: neoChir,
        code: 'NEO CHIR',
        sortIndex: 7600,
        type: 2
      },

      mixRea: {
        id: 'mixRea',
        index: 1300,
        list: mixRea,
        code: 'MIX REA',
        sortIndex: 10600,
        type: 1
      }
    }
  }

  return {
    v1: build(adDia.v1, null),
    v2: build(
      adDia.v2,
      [
        {
          index: 2200,
          code: go.units.specialities.AdDiaHdc.code,
          unitType: go.units.specialities.AdDiaHdc.index,
          id: 'adDiaHdc',
          sortIndex: 8899,
          type: 5
        },
        {
          index: 2201,
          code: go.units.specialities.AdDiaUdm.code,
          unitType: go.units.specialities.AdDiaUdm.index,
          id: 'adDiaUdm',
          sortIndex: 8898,
          type: 5
        },
        {
          index: 2202,
          code: go.units.specialities.AdDiaUad.code,
          unitType: go.units.specialities.AdDiaUad.index,
          id: 'adDiaUad',
          sortIndex: 8897,
          type: 5
        },
        {
          index: 2203,
          code: go.units.specialities.AdDiaDom.code,
          unitType: go.units.specialities.AdDiaDom.index,
          id: 'adDiaDom',
          sortIndex: 8896,
          type: 5
        }
      ]
    )
  }
})()

const specialities = (function () {
  function build (d, r) {
    const result = r
    for (let key in d) {
      const disc = d[key]
      result[disc.id] = {
        code: disc.code,
        index: disc.index,
        sortIndex: disc.sortIndex,
        type: disc.type,
        id: disc.id,
        subtitle: disc.subtitle
      }

      if (disc.expands) {
        for (let i = 0; i !== disc.expands.length; ++i) {
          const spe = disc.expands[i]
          result[spe.id] = {
            code: spe.code,
            index: spe.index,
            unitType: spe.unitType,
            sortIndex: spe.sortIndex,
            type: spe.type,
            discipline: disc,
            id: spe.id
          }
        }
      }

      if (disc.optionals) {
        for (let i = 0; i !== disc.optionals.length; ++i) {
          const spe = disc.optionals[i]
          result[spe.id] = {
            code: spe.code,
            index: spe.index,
            unitType: spe.unitType,
            sortIndex: spe.sortIndex,
            type: spe.type,
            discipline: disc,
            id: spe.id
          }
        }
      }
    }

    return result
  }
  return {
    v1: build(
      disc.v1,
      {
        Can: {
          code: `AD CAN + PED CAN`,
          sortIndex: 9600
        },

        Hem: {
          code: `AD HEM + PED HEM`,
          sortIndex: 9500
        },

        Rad: {
          code: `AD RAD + PED RAD`,
          sortIndex: 9400
        }
      }
    ),
    v2: build(disc.v1, {}),
    v3: build(disc.v2, {})
  }
})()

const neoAndMix = list.v1.filter(e => isNeo(e.index) || isMix(e.index))

function codeFromIndex (index) {
  const u = this.list.find(l => l.index === index)
  return u == null ? '' : u.code
}

function discFromIndex (index) {
  for (let i in this.disc) {
    const d = this.disc[i]
    if (d.list.find(l => l.index === index) != null) {
      return d
    }
  }
  return null
}

function findFromCode (code) {
  return this.list.find(e => e.code === code)
}

function findFromIndex (index) {
  return this.list.find(e => e.index === index)
}

const v1 = {
  list: list.v1,
  infADI: infADI.v1,
  adRea,
  pedRea,
  neoAndMix,
  disc: disc.v1,
  specialities: specialities.v1,

  codeFromIndex,
  discFromIndex,

  find: findFromCode,
  findFromIndex,

  isInfADI: isInfADI.v1,
  isDia: isDia.v1,
  isNeo: isNeo,
  isMix: isMix
}

const v2 = {
  list: list.v1,
  infADI: infADI.v1,
  adRea,
  pedRea,
  neoAndMix,
  disc: disc.v1,
  specialities: specialities.v2,

  codeFromIndex,
  discFromIndex,

  find: findFromCode,
  findFromIndex,

  isInfADI: isInfADI.v1,
  isDia: isDia.v1,
  isNeo: isNeo,
  isMix: isMix
}

const v3 = {
  list: list.v2,
  infADI: infADI.v2,
  adRea: adRea,
  pedRea: pedRea,
  neoAndMix: neoAndMix,

  disc: disc.v2,
  specialities: specialities.v3,

  codeFromIndex,
  discFromIndex,

  find: findFromCode,
  findFromIndex,

  isInfADI: isInfADI.v2,
  isDia: isDia.v2,
  isNeo: isNeo,
  isMix: isMix
}

export default {
  '2019': v1,
  '2020': v2,
  '2021': v2,
  '2022': v2,
  '2023': v2,
  '2024': v3,
  '2025': v3,
  '2026': v3
}
